import React, { Fragment } from 'react';
import WithdrawalDetailsContent from '../../components/account/WithdrawalDetailsContent';
const Deposit = () => {
    
    return (
      <Fragment>
            <div className="title_wrap">
                <div className="title_box">
                    <div className="title">환전내역</div>
                </div>
            </div>
            <WithdrawalDetailsContent></WithdrawalDetailsContent>    
            
      </Fragment>
    );
};

export default Deposit;


// WEBPACK FOOTER //
// ./src/containers/Account/WithdrawalDetails.js